export const overdueReportTicketSelectors = {
  requestButton: (patientId: number) => `overdue-report-ticket-${patientId}-request-button`,
  requestMenu: (patientId: number) => `overdue-report-ticket-${patientId}-request-menu`,
  snoozeButton: (patientId: number) => `overdue-report-ticket-${patientId}-snooze-button`,
  automatedReportCallButton: (patientId: number) =>
    `overdue-report-ticket-${patientId}-automated-report-call-button`,
  smsReminderButton: (patientId: number) => `overdue-report-ticket-${patientId}-sms-reminder-button`
};
